import { CheckField, SelectField, TextField } from '@ff-it/form';
import { Icon } from '@ff-it/ui';
import { factorFormOptions, factorKindOptions } from 'core/types';
import { FactorKindRateFields } from 'modules/supplier/factors/FactorKindRateFields';
import { ReactElement } from 'react';
import { required } from 'utilities';

export function VendorFactorForm(): ReactElement {
  return (
    // width for plan factor dialog
    <div className="container px-0 ml-0" style={{ minWidth: '500px' }}>
      <div className="form-row">
        <TextField name="name" label="Name" required validate={required} className="col-6" />
        <CheckField
          name="auto_apply"
          label={
            <>
              <Icon icon="bolt-auto" /> Auto apply
            </>
          }
          className="col-6"
          variant="checkbox"
          fieldLabel="Auto apply to plan rows"
          help="Media rows with standard activities"
          size="sm"
        />
      </div>
      <div className="form-row">
        <TextField name="description" label="Description" multiline className="col-12" />
      </div>
      <div className="form-row">
        <SelectField
          name="kind"
          label="Kind"
          required
          validate={required}
          simple
          options={factorKindOptions}
          className="col-6"
        />
        <SelectField
          name="form"
          label="Form"
          required
          validate={required}
          simple
          options={factorFormOptions}
          className="col-6"
        />
      </div>
      <FactorKindRateFields />
    </div>
  );
}
